import React, { Component } from 'react';
import Sidebar from './Sidebar';
import { loadURL } from '../utils.js';
import { config } from '../config.js';


// Component reference for dynamically rendering the component
// @TODO move icons to CSS, then swap to <svg> with Javascript so they can be styled
const menu = [
  // { menu: 'main', title: 'Status', icon: 'icon-status.svg', component: StatusPage },
  { menu: 'main', title: 'Integration tests', icon: 'icon-import.svg', component: "integration" },
  { menu: 'main', title: 'Cross-refs tests', icon: 'icon-import.svg', component: "crossrefs" },
  { menu: 'main', title: 'Runtime errors', icon: 'icon-status.svg', component: "runtimeerror" },
  { menu: 'main', title: 'Queue Status', icon: 'icon-import.svg', component: "queue" },
  { menu: 'main', title: 'Export Status', icon: 'icon-warning3.svg', component: "exports" },
  { menu: 'main', title: 'Global Settings', icon: 'icon-list.svg', component: "settings" },
  { menu: 'main', title: 'Notification Settings', icon: 'icon-tick.svg', component: "status" },
  { menu: 'main', title: 'Entity Names', icon: 'icon-tick.svg', component: "entitynames" },
  { menu: 'main', title: 'Release Notes', icon: 'icon-tick.svg', component: "releasenotes" },
  { menu: 'main', title: 'Email Validator', icon: 'icon-tick.svg', component: "emailvalidator" },
  { menu: 'main', title: 'Content Scraper', icon: 'icon-tick.svg', component: "contentscraper" },

  // { menu: 'entity', title: 'Entity diagnostics', icon: 'icon-book.svg', component: "diagnostic" },
  { menu: 'entity', title: 'CSV export test', icon: 'icon-csv.svg', component: "csv" },
  // { menu: 'entity', title: 'HTML export test', icon: 'icon-html.svg', component: "html" },
  { menu: 'entity', title: 'Data export test', icon: 'icon-data.svg', component: "data" },
  { menu: 'entity', title: 'Drupal import test', icon: 'icon-drupal.svg', component: "drupal" },
];
menu.forEach((item, index) => { item.id = index.toString(); });

export default class Container extends Component {
  constructor(props) {
    super(props);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleEntityChange = this.handleEntityChange.bind(this);
    this.handleYearChange = this.handleYearChange.bind(this);
    this.state = {
      entities: [],
      activeEntity: false,
      activeYear: false,
      activePage: '1'
    };
  }

  // Load list of entities (from Drupal)
  loadEntities(url) {
    // @TOXO this needs to include:
    // - entity name -> dropdown
    // - entity UUID -> Data export test
    // - acronym -> CSV export test
    // - batch -> CSV export test
    // - publication URL -> Drupal import test
    loadURL(config.proxy + `?url=${config.entities}`, 'json')
      .then((data) => {
        console.log('entities (Drupal):', data);
        this.setState({ entities: data || [] });
      });
  }

  // Load list of reports (from MasterDocs)
  // loadReports(url) {
  //   loadURL(config.proxy + '?url=' + config.reports, 'csv')
  //     .then((data) => {
  //       console.log('reports (MasterDocs):', data);
  //       // this.setState({ reports: data });
  //     });
  // }

  componentDidMount() {
    this.loadEntities();
    // this.loadReports();
  }

  // todo: add router
  // Changes page when clicking a menu item
  handlePageChange(e) {
    this.setState({activePage: e.target.value});
  }

  // Changes entity from dropdown
  handleEntityChange(entity) {
    this.setState({activeEntity: entity.value});
  }

  // Changes year from dropdown
  handleYearChange(year) {
    this.setState({activeYear: year.value});
  }

  render() {
    const { appdetails } = this.props;
    const { activePage, activeEntity, activeYear } = this.state;
    // Switches to the active content pages
    // const page = menu.find(item => item.id === activePage).component;
    return (
      <div className='container'>
        <Sidebar
          activeEntity={activeEntity}
          activePage={activePage}
          activeYear={activeYear}
          entities={this.state.entities}
          menu={menu}
          onEntityChange={this.handleEntityChange}
          onYearChange={this.handleYearChange}
          onPageChange={this.handlePageChange}
        />
        <div className='page'>
          {this.props.children}
        </div>
      </div>
    );
  }
}
